import { render, staticRenderFns } from "./BookingsSold.vue?vue&type=template&id=37b0f98c&scoped=true&"
import script from "./BookingsSold.vue?vue&type=script&lang=js&"
export * from "./BookingsSold.vue?vue&type=script&lang=js&"
import style0 from "./BookingsSold.vue?vue&type=style&index=0&id=37b0f98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0f98c",
  null
  
)

export default component.exports